module.exports = __webpack_public_path__ + "img/a34e7b7f9ba6af3964b426713771c26f.png";